import React from "react";
import '../styles/Header.css';
const Header = () => {
  return (
    <header className="header">
      {/* 左侧 Logo */}
      <div className="header-title">playsgame.online</div>
      
      {/* 搜索框 */}
      {/* <div className="search-container">
            <input type="text" className="search-input" placeholder="Search" />
            <button className="search-button">🔍</button>
      </div> */}

      {/* 用户登录按钮 */}
      {/* <div className="text-white flex items-center">
        <button className="bg-blue-500 px-3 py-2 rounded-md hover:bg-blue-600 transition">
          Login
        </button>
      </div> */}
      
    </header>
  );
};

export default Header;
